var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNaver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2190_398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.82 33H4.18C1.892 33 0 31.108 0 28.82V4.18C0 1.892 1.892 0 4.18 0H28.82C31.108 0 33 1.892 33 4.18V28.82C33 31.108 31.108 33 28.82 33ZM4.18 2.2C3.08 2.2 2.2 3.08 2.2 4.18V28.82C2.2 29.92 3.08 30.8 4.18 30.8H28.82C29.92 30.8 30.8 29.92 30.8 28.82V4.18C30.8 3.08 29.92 2.2 28.82 2.2H4.18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5358 17.0722L13.2438 8.09619H8.00781V24.9042H13.4638V15.9282L19.7558 24.9042H24.9478V8.09619H19.5358V17.0722Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2190_398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNaver);
export default __webpack_public_path__ + "static/media/icon-naver.a6a68c4e6e4266c5c5f284676d9569a6.svg";
export { ForwardRef as ReactComponent };